var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rreferanse",attrs:{"id":"back1"}},[_c('div',{staticClass:"form-wrap container"},[_c('v-carousel',_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src}})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }